export const rorAuthKeys = {
  'FJ-Apikey': process.env.NEXT_PUBLIC_FJ_API_KEY,
  FJAuthorizationKey: process.env.NEXT_PUBLIC_FJ_AUTH_KEY,
};
